import { QuizItemCache } from '../../../../api/quiz/getQuizzes/normalize/toQuizItemCache';
import { QuizOrFolder } from '../../../../api/quiz/getQuizzes/types';

const isNotDeletedOrNameless = (item) => item.name && !item.deleted;

const isFolder = (canMakeFolders: boolean) => (item) =>
  canMakeFolders || item.type !== 'folder';

const matchesSearchQuery = (searchQuery: string) => (item) => {
  return item.name.toUpperCase().includes(searchQuery.toUpperCase());
};

interface SearchQueryFilterParams {
  searchQuery: string;
  canMakeFolders: boolean;
}

export const getSearchQueryFilter =
  ({ searchQuery, canMakeFolders }: SearchQueryFilterParams) =>
  (items: QuizItemCache): QuizOrFolder[] => {
    if (!searchQuery) {
      return items.rootItems
        .map((id) => items.itemById[id])
        .filter(isNotDeletedOrNameless)
        .filter(isFolder(canMakeFolders));
    }

    return Object.values(items.itemById)
      .filter(isNotDeletedOrNameless)
      .filter(isFolder(canMakeFolders))
      .filter(matchesSearchQuery(searchQuery));
  };
